import { pushStorage } from './store/package-storage';
import { sendPackage } from './helpers/send-package';
import { checkErrors } from './check-errors';
import { getEventData } from './store/get-event-data';

/**
 * Структура business-события
 */

const pushEvent = async (event, eventType, immediately = false) => {
  const eventData = await getEventData(event, eventType);
  checkErrors();
  if (immediately) {
    await sendPackage(eventData);
  } else {
    pushStorage(eventData);
  }
};

/**
 * Отправка бизнес события
 * @param {BaseItem} event объект события
 * @return {void}
 */
export const sendEvent = async event => {
  await pushEvent(event, 'business');
};

/**
 * Отправка технического события
 * @param {BaseItem} event объект события
 * @return {void}
 */
export const sendTechEvent = async event => {
  await pushEvent(event, 'technical');
};

/**
 * Отправка чувсвительного к данным события
 * @param {BaseItem} event объект события
 * @return {void}
 */
export const sendSensitiveEvent = async event => {
  await pushEvent(event, 'sensitive', true);
};